import { action, computed, observable, makeAutoObservable } from 'mobx';
import { RouterType } from 'src/AppState/AppState';

export class CustomerTabState {
    private readonly router: RouterType | null;
    @observable tabName: string | number;

    constructor(router: RouterType | null) {
        this.router = router;
        this.tabName = '';
        makeAutoObservable(this);
    }

    @computed get filterTab(): string | undefined {
        try {
            const customerParam =
                this.router !== null &&
                this.router.parameters['*global:customers.parameters'] &&
                JSON.parse(this.router.parameters['*global:customers.parameters']);
            return customerParam ? customerParam.auditFilter : '';
        } catch (error) {
            console.log(error);
        }
    }

    @action getTabName = (tabName: string | number): void => {
        this.tabName = tabName;
    };
}
